import React from "react";

const Button: React.FunctionComponent<SmallCardButtonProps> = (
  props: SmallCardButtonProps
) => {
  return (
    <button
      className={`
      btn small-card-btn 
      ${props.block ? "btn-block" : ""}
      ${props.active ? "btn-active" : ""}
      `}
      onClick={props.onClick}
    >
      {props.icon && (
        <div
          className={`btn-icon ${props.anim ? "btn-anim" : ""} 
        `}
        >
          {typeof props.icon === "string" && (
            <img src={props.icon} alt={props.iconAlt} width="100%" />
          )}
          {React.isValidElement(props.icon) && props.icon}
        </div>
      )}
      {typeof props.label === "string" && props.label}
      {React.isValidElement(props.label) && props.label}
    </button>
  );
};

interface SmallCardButtonProps extends React.HTMLProps<HTMLButtonElement> {
  label: string | React.ReactComponentElement<any> | any;
  active?: boolean;
  icon?: React.ReactComponentElement<any> | string;
  anim?: boolean;
  block?: boolean;
  iconAlt?: string;
}

export default Button;
